import * as lazyIndex from './lazyIndex';
import ItemReadingPaneHostPlaceholder from './components/ItemReadingPaneHostPlaceholder';
import { getOwaLazyErrorConfig } from 'mini-error-handler/lib/utils/getOwaLazyErrorConfig';
import { LazyModule } from 'owa-bundling';
import { withNetworkErrorHandler } from 'mini-error-handler/lib/components/withNetworkErrorHandler';
// closeItemReadingPaneMutator is needed to make sure that reading pane transitions work as expected once the deep-link is closed
import 'mini-mail-reading-pane-store/lib/mutators/closeItemReadingPaneMutator';
import 'mini-mail-reading-pane-store/lib/mutators/setIsRecipientWellTruncatedMutator';
import 'mini-mail-reading-pane-store/lib/mutators/toggleItemHeaderMutator';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(/* webpackChunkName: "ItemReadingPaneHost" */ './lazyIndex')
);

/**
 * Export LazyComponent ItemReadingPaneHost component
 */
const LazyItemReadingPaneHost = withNetworkErrorHandler(
    null,
    getOwaLazyErrorConfig(lazyModule, m => m.ItemReadingPaneHost, ItemReadingPaneHostPlaceholder)
);

export default LazyItemReadingPaneHost;
